import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { datadogInit } from '@config/datadog-rum';

registerLocaleData(localeEs, 'es');
datadogInit();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
